/* LUKACHARI Club line in the cart (21.09.2026).
   Reads the member's tier, points and next reward from Rivo's app proxy (same data the Rivo window uses)
   and shows them above the subtotal. The button opens the Rivo window (assets/lk-rivo-he.js). */
(function () {
  if (!document.getElementById('lkpr-css')) {
    var st = document.createElement('style');
    st.id = 'lkpr-css';
    st.textContent =
      '.lkpr{display:block;margin:0 0 14px;padding:14px 16px;border:1px solid rgba(9,71,53,.16);border-radius:12px;background:#FCF6EB;color:#094735;font-size:14px;line-height:1.45;direction:rtl;text-align:right}' +
      '.lkpr__row{display:flex;align-items:center;justify-content:space-between;gap:12px}' +
      '.lkpr__t,.lkpr__s,.lkpr__tier{margin:0}' +
      '.lkpr__t b{font-weight:600}' +
      '.lkpr__badge{display:inline-block;margin-inline-end:6px;padding:1px 9px;border-radius:100px;background:#094735;color:#FCF6EB;font-size:12px;font-weight:500;vertical-align:1px}' +
      '.lkpr__s{margin-top:4px;color:#5d6b63;font-size:13px}' +
      '.lkpr__tier{margin-top:10px;padding-top:10px;border-top:1px solid rgba(9,71,53,.12);font-size:13px}' +
      '.lkpr__tier[hidden]{display:none}' +
      '.lkpr__bar{height:4px;margin-top:6px;border-radius:4px;background:rgba(9,71,53,.12);overflow:hidden}' +
      '.lkpr__bar i{display:block;height:100%;background:#094735;border-radius:4px}' +
      '.lkpr__btn{flex:none;border:0;border-radius:100px;background:#094735;color:#FCF6EB;font:inherit;font-size:13px;font-weight:500;padding:9px 18px;cursor:pointer;white-space:nowrap}' +
      '.lkpr a{color:#094735;text-decoration:underline}';
    document.head.appendChild(st);
  }
  if (!window.customElements || window.customElements.get('lk-club-line')) return;

  function fmt(n) { return Math.round(Number(n) || 0).toLocaleString('he-IL'); }
  function getJSON(url) {
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }

  class LkClubLine extends HTMLElement {
    connectedCallback() {
      if (this._started) return;
      this._started = true;
      var cid = this.dataset.cid;
      if (!cid) return;
      var total = Number(this.dataset.total) || 0;
      var title = this.querySelector('[data-lkpr-title]');
      var sub = this.querySelector('[data-lkpr-sub]');
      var tierEl = this.querySelector('[data-lkpr-tier]');
      var base = '/apps/ba-loy/customer';

      Promise.all([
        getJSON(base + '/' + cid + '.json').catch(function () { return null; }),
        getJSON(base + 's/' + cid + '/vip_tiers.json').catch(function () { return null; }),
        getJSON(base + 's/' + cid + '/next_reward.json').catch(function () { return null; })
      ]).then(function (res) {
        var c = res[0] && (res[0].customer || res[0]);
        var vip = res[1] && res[1].success !== false ? res[1] : null;
        var next = res[2] && res[2].reward;
        var pts = c && c.points_tally != null ? Number(c.points_tally) : null;
        var tierName = vip && vip.tier && vip.tier.name;

        if (pts != null) {
          title.innerHTML = (tierName ? '<span class="lkpr__badge"></span>' : '') + 'יש לך <b>' + fmt(pts) + '</b> נקודות';
          if (tierName) title.querySelector('.lkpr__badge').textContent = tierName;
        }
        if (pts != null && next && next.points_amount) {
          var need = Number(next.points_amount);
          sub.textContent = pts >= need
            ? 'אפשר להפוך ' + fmt(need) + ' נקודות ל־' + next.name + ' בהזמנה הזו.'
            : 'עוד ' + fmt(need - pts) + ' נקודות ל־' + next.name + '.';
        }

        if (vip && tierEl) {
          if (vip.highest_tier) {
            tierEl.textContent = 'המעמד הגבוה ביותר במועדון כבר שלך.';
            tierEl.hidden = false;
          } else if (vip.next_tier && vip.next_tier.name) {
            var left = Number(vip.next_tier.to_spend_or_earn) || 0;
            var threshold = Number(vip.next_tier.threshold) || 0;
            var spent = Number(vip.current_period_spend) || Math.max(0, threshold - left);
            var msg;
            if (left > 0 && total >= left) {
              msg = 'ההזמנה הזו מעלה אותך למעמד ' + vip.next_tier.name + '.';
            } else if (left > 0) {
              msg = 'עוד ₪' + fmt(left - total) + ' ברכישות אחרי ההזמנה הזו ומגיעים ל־' + vip.next_tier.name + '.';
            }
            if (msg) {
              var pct = threshold > 0 ? Math.min(100, Math.round(((spent + total) / threshold) * 100)) : 0;
              tierEl.textContent = msg;
              var bar = document.createElement('div');
              bar.className = 'lkpr__bar';
              bar.innerHTML = '<i style="width:' + pct + '%"></i>';
              tierEl.appendChild(bar);
              tierEl.hidden = false;
            }
          }
        }
      });
    }
  }
  window.customElements.define('lk-club-line', LkClubLine);
})();
